import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { ContentPipe } from 'src/app/services/content/content.pipe';
import { DropdownOption } from 'src/app/shared/mine-dropdown/mine-dropdown.interface';
import { AssessmentPage, AssessmentTableStatus } from '../models/assessments.interface';

@Pipe({
    standalone: true,
    name: 'assessmentStatus'
})
export class AssessmentStatusPipe implements PipeTransform {

    constructor(
        private datePipe: DatePipe,
        private contentPipe: ContentPipe,
    ) {}

    transform(instance: AssessmentPage): AssessmentTableStatus {
        const statuses = this.contentPipe.transform('ai-assessments.statuses') as DropdownOption[];
        return {
            date: this.datePipe.transform(instance.updatedDate ?? instance.createdDate, 'MMM y'),
            status: statuses.find(status => status.id === instance.state)
        } as AssessmentTableStatus;
    }
}